import React from "react";
import VideoListView from "./VideoListView";

const VideoPage: React.FC = () => {
  return (
    <div className="flex overflow-hidden bg-bgColor w-full">
      {/* Search bar and options */}
      <div className="w-full pt-5 pl-6 overflow-hidden h-full">
        <VideoListView />
      </div>
    </div>
  );
};

export default VideoPage;
